/**
 * @desc 入库逆向流程
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inMaster.inMasterReverse.Params, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/inMasterReverse`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
